import { render, staticRenderFns } from "./collectionSet.vue?vue&type=template&id=e490c5a8&scoped=true"
import script from "./collectionSet.vue?vue&type=script&lang=js"
export * from "./collectionSet.vue?vue&type=script&lang=js"
import style0 from "./collectionSet.vue?vue&type=style&index=0&id=e490c5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e490c5a8",
  null
  
)

export default component.exports